/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, CheckboxGroup } from '@nextui-org/react';
import { Controller, useFormContext } from 'react-hook-form';
import Text from '../Text';
interface IItems {
  value: string;
  label: string | React.ReactNode;
}
interface ICheckboxCustom {
  items: IItems[];
  name: string;
  label?: string;
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full' | undefined;
  size?: 'sm' | 'md' | 'lg' | undefined;
  checkboxGroupClassName?: string;
}

const RHFCheckbox = (props: ICheckboxCustom) => {
  const { items, name, label, size, radius, checkboxGroupClassName, ...rest } = props;
  const { control } = useFormContext<any>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange: onFieldChange } }) => (
        <div>
          {label && (
            <div className='mb-[6px] flex gap-1'>
              <div className='text-primary font-medium text-sm'>{label}</div>
            </div>
          )}
          <CheckboxGroup
            value={value}
            size={size}
            classNames={{
              wrapper: `gap-4 ${checkboxGroupClassName || ''}`,
            }}
            radius={radius}
            color='primary'
            onValueChange={(e) => {
              onFieldChange(e);
            }}
            {...rest}
          >
            {items?.map((item) => {
              return (
                <div key={item?.value} className='flex items-center gap-2'>
                  <Checkbox
                    classNames={{
                      wrapper:
                        'before:border-borderPrimary before:border-1  group-data-[hover=true]:before:bg-transparent group-data-[selected=true]:after:bg-bg-brand-solid',
                    }}
                    key={item?.value}
                    value={item?.value}
                  />
                  <Text type='font-14-400'>{item?.label}</Text>
                </div>
              );
            })}
          </CheckboxGroup>
        </div>
      )}
    />
  );
};

export default RHFCheckbox;
